export const MAX_RECENTS = 3;
export const WORLDWIDE = 999;
export const TOOLTIP_DELAY = 200;
export const EMPTY_COMPETITORS_COUNT = 3;
export const EMPTY_VALUE = 0.323;
export const EMPTY_COMPANY_NAME = "mycompany.com";
